import { render } from "./OrderOverviewListItem.vue?vue&type=template&id=0544ad2a&scoped=true"
import script from "./OrderOverviewListItem.vue?vue&type=script&lang=js"
export * from "./OrderOverviewListItem.vue?vue&type=script&lang=js"

import "./OrderOverviewListItem.vue?vue&type=style&index=0&id=0544ad2a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Gourmetta-RCS-Customer-Orders---Web-App/Gourmetta-RCS-Customer-Orders---Web-App/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0544ad2a"]])

export default __exports__